import { Flex, Input, Text } from '@chakra-ui/core'
import { InputProps } from '@chakra-ui/core/dist/Input'
import { ErrorMessage, FieldProps } from 'formik'
import * as React from 'react'
import { Label, LabelProps } from '../ConnectedFormGroup/styles'

export type ConnectedPhoneNumberProps = LabelProps &
  FieldProps &
  InputProps & {
    label?: string
  }

const ConnectedPhoneNumber: React.FC<ConnectedPhoneNumberProps> = ({
  type,
  label,
  field,
  placeholder,
  ...rest
}) => (
  <Flex flexDirection="column" width="100%" mr={rest.mr} ml={rest.ml} mt={rest.mt} mb={rest.mb}>
    {label && <Label htmlFor={field.name}>{label}</Label>}
    {/* <Flex alignItems='center' paddingLeft='10px'> */}
    <Input
      {...field}
      type={type}
      id={field.name}
      placeholder={placeholder || label}
      {...rest}
      maxLength={20}
    />
    {/* <IconButton aria-label="Copy" icon="copy"> </IconButton>
    </Flex> */}
    <ErrorMessage name={field.name}>
      {(msg) => (
        <Text color="red.500" textAlign="right">
          {msg}
        </Text>
      )}
    </ErrorMessage>
  </Flex>
)

export default ConnectedPhoneNumber

ConnectedPhoneNumber.defaultProps = {
  mb: 2,
  type: 'text',
  fontWeight: 'lighter'
}
